import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1c84ad1a = () => interopDefault(import('..\\pages\\appbh.vue' /* webpackChunkName: "pages/appbh" */))
const _b90f88d8 = () => interopDefault(import('..\\pages\\error\\404.vue' /* webpackChunkName: "pages/error/404" */))
const _b90f518c = () => interopDefault(import('..\\pages\\error\\pay-success.vue' /* webpackChunkName: "pages/error/pay-success" */))
const _ec69f29c = () => interopDefault(import('..\\pages\\jiantou\\claim.vue' /* webpackChunkName: "pages/jiantou/claim" */))
const _5e0b5b70 = () => interopDefault(import('..\\pages\\web\\bhquery\\index.vue' /* webpackChunkName: "pages/web/bhquery/index" */))
const _6af45e1d = () => interopDefault(import('..\\pages\\web\\ggzybh\\index.vue' /* webpackChunkName: "pages/web/ggzybh/index" */))
const _026253c7 = () => interopDefault(import('..\\pages\\web\\online-service\\index.vue' /* webpackChunkName: "pages/web/online-service/index" */))
const _0e03107a = () => interopDefault(import('..\\pages\\web\\register.vue' /* webpackChunkName: "pages/web/register" */))
const _c17fab9c = () => interopDefault(import('..\\pages\\web\\zbdl\\index.vue' /* webpackChunkName: "pages/web/zbdl/index" */))
const _d61f2672 = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\index.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/index" */))
const _85d369be = () => interopDefault(import('..\\pages\\branch\\bhtong\\bh-query\\index.vue' /* webpackChunkName: "pages/branch/bhtong/bh-query/index" */))
const _3d988478 = () => interopDefault(import('..\\pages\\branch\\bhtong\\finance\\index.vue' /* webpackChunkName: "pages/branch/bhtong/finance/index" */))
const _46cc8991 = () => interopDefault(import('..\\pages\\branch\\bhtong\\help-center\\index.vue' /* webpackChunkName: "pages/branch/bhtong/help-center/index" */))
const _1d7d2a80 = () => interopDefault(import('..\\pages\\branch\\bhtong\\index\\index.vue' /* webpackChunkName: "pages/branch/bhtong/index/index" */))
const _d6686d18 = () => interopDefault(import('..\\pages\\branch\\bhtong\\joinpartner\\index.vue' /* webpackChunkName: "pages/branch/bhtong/joinpartner/index" */))
const _cb3b9d10 = () => interopDefault(import('..\\pages\\branch\\common\\aboutus\\index.vue' /* webpackChunkName: "pages/branch/common/aboutus/index" */))
const _ae79dc42 = () => interopDefault(import('..\\pages\\branch\\fybh\\index\\index.vue' /* webpackChunkName: "pages/branch/fybh/index/index" */))
const _8b336588 = () => interopDefault(import('..\\pages\\branch\\mancheng\\bh-query\\index.vue' /* webpackChunkName: "pages/branch/mancheng/bh-query/index" */))
const _3022d645 = () => interopDefault(import('..\\pages\\branch\\mancheng\\index\\index.vue' /* webpackChunkName: "pages/branch/mancheng/index/index" */))
const _591a2aa6 = () => interopDefault(import('..\\pages\\branch\\ysbh\\index\\index.vue' /* webpackChunkName: "pages/branch/ysbh/index/index" */))
const _0a107468 = () => interopDefault(import('..\\pages\\branch\\zceb\\index\\index.vue' /* webpackChunkName: "pages/branch/zceb/index/index" */))
const _37f6610e = () => interopDefault(import('..\\pages\\sys\\all\\all.vue' /* webpackChunkName: "pages/sys/all/all" */))
const _d203755a = () => interopDefault(import('..\\pages\\sys\\applybh\\paybh.vue' /* webpackChunkName: "pages/sys/applybh/paybh" */))
const _16db29c4 = () => interopDefault(import('..\\pages\\sys\\applybh\\payend.vue' /* webpackChunkName: "pages/sys/applybh/payend" */))
const _bcda9eec = () => interopDefault(import('..\\pages\\sys\\bhcheck\\detail.vue' /* webpackChunkName: "pages/sys/bhcheck/detail" */))
const _11c56e97 = () => interopDefault(import('..\\pages\\sys\\bhcheck\\list.vue' /* webpackChunkName: "pages/sys/bhcheck/list" */))
const _07630884 = () => interopDefault(import('..\\pages\\sys\\bhcheck\\print.vue' /* webpackChunkName: "pages/sys/bhcheck/print" */))
const _3aae1562 = () => interopDefault(import('..\\pages\\sys\\coupons\\list.vue' /* webpackChunkName: "pages/sys/coupons/list" */))
const _2ad5c6be = () => interopDefault(import('..\\pages\\sys\\filecustomerdwmg\\list.vue' /* webpackChunkName: "pages/sys/filecustomerdwmg/list" */))
const _20c012b4 = () => interopDefault(import('..\\pages\\sys\\ggzy\\bh-auto\\index.vue' /* webpackChunkName: "pages/sys/ggzy/bh-auto/index" */))
const _2b252568 = () => interopDefault(import('..\\pages\\sys\\mailaddressmg\\list.vue' /* webpackChunkName: "pages/sys/mailaddressmg/list" */))
const _07268ee9 = () => interopDefault(import('..\\pages\\sys\\ordermg\\bh-detail.vue' /* webpackChunkName: "pages/sys/ordermg/bh-detail" */))
const _2c5de1e5 = () => interopDefault(import('..\\pages\\sys\\ordermg\\list\\index.vue' /* webpackChunkName: "pages/sys/ordermg/list/index" */))
const _7974250e = () => interopDefault(import('..\\pages\\sys\\ordermg\\list-usertype-1\\index.vue' /* webpackChunkName: "pages/sys/ordermg/list-usertype-1/index" */))
const _e4f04f56 = () => interopDefault(import('..\\pages\\sys\\receiptinfomg\\list.vue' /* webpackChunkName: "pages/sys/receiptinfomg/list" */))
const _0cbb3670 = () => interopDefault(import('..\\pages\\sys\\userinfo\\list.vue' /* webpackChunkName: "pages/sys/userinfo/list" */))
const _b2b95636 = () => interopDefault(import('..\\pages\\sys\\zb-notice\\detail.vue' /* webpackChunkName: "pages/sys/zb-notice/detail" */))
const _4bd96db2 = () => interopDefault(import('..\\pages\\sys\\zb-notice\\list.vue' /* webpackChunkName: "pages/sys/zb-notice/list" */))
const _e0963880 = () => interopDefault(import('..\\pages\\web\\all\\all.vue' /* webpackChunkName: "pages/web/all/all" */))
const _a664fdde = () => interopDefault(import('..\\pages\\web\\query\\main.vue' /* webpackChunkName: "pages/web/query/main" */))
const _6535f4a2 = () => interopDefault(import('..\\pages\\branch\\bhtong\\bh-query\\res.vue' /* webpackChunkName: "pages/branch/bhtong/bh-query/res" */))
const _7bca6fe4 = () => interopDefault(import('..\\pages\\branch\\bhtong\\news\\detail.vue' /* webpackChunkName: "pages/branch/bhtong/news/detail" */))
const _57fdaec4 = () => interopDefault(import('..\\pages\\branch\\bhtong\\news\\newslist.vue' /* webpackChunkName: "pages/branch/bhtong/news/newslist" */))
const _32725f8a = () => interopDefault(import('..\\pages\\sys\\ggzy\\virtual-money-acc\\detail.vue' /* webpackChunkName: "pages/sys/ggzy/virtual-money-acc/detail" */))
const _482fc688 = () => interopDefault(import('..\\pages\\sys\\ggzy\\virtual-money-acc\\list.vue' /* webpackChunkName: "pages/sys/ggzy/virtual-money-acc/list" */))
const _0da6fd0a = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-file\\detail.vue' /* webpackChunkName: "pages/sys/ggzy/zb-file/detail" */))
const _10fa49d2 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-file\\list.vue' /* webpackChunkName: "pages/sys/ggzy/zb-file/list" */))
const _73bb1f26 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\detail.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/detail" */))
const _4590a54e = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\form.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/form" */))
const _1d3c4554 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\form-fast-add.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/form-fast-add" */))
const _1130d433 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\list.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/list" */))
const _81d7c6c4 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-pro\\list.vue' /* webpackChunkName: "pages/sys/ggzy/zb-pro/list" */))
const _a53f6efe = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-pro\\list-bd.vue' /* webpackChunkName: "pages/sys/ggzy/zb-pro/list-bd" */))
const _6568a46c = () => interopDefault(import('..\\pages\\sys\\guarantee\\hanhua\\hhly-apply.vue' /* webpackChunkName: "pages/sys/guarantee/hanhua/hhly-apply" */))
const _2b8e694a = () => interopDefault(import('..\\pages\\web\\guarantee\\hanhua\\form.vue' /* webpackChunkName: "pages/web/guarantee/hanhua/form" */))
const _ad385af6 = () => interopDefault(import('..\\pages\\web\\guarantee\\hanhua\\hhly-apply.vue' /* webpackChunkName: "pages/web/guarantee/hanhua/hhly-apply" */))
const _19a570c6 = () => interopDefault(import('..\\pages\\web\\guarantee\\huanghe\\form.vue' /* webpackChunkName: "pages/web/guarantee/huanghe/form" */))
const _6075962b = () => interopDefault(import('..\\pages\\web\\guarantee\\tianan\\form.vue' /* webpackChunkName: "pages/web/guarantee/tianan/form" */))
const _bc4d77b2 = () => interopDefault(import('..\\pages\\web\\guarantee\\yangguang\\form.vue' /* webpackChunkName: "pages/web/guarantee/yangguang/form" */))
const _5a2221bc = () => interopDefault(import('..\\pages\\web\\guarantee\\zhonghua\\form-xm.vue' /* webpackChunkName: "pages/web/guarantee/zhonghua/form-xm" */))
const _4e5aad04 = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\sectioins\\company-introduction.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/sectioins/company-introduction" */))
const _98f4d7ec = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\sectioins\\platform-introduction.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/sectioins/platform-introduction" */))
const _3f7b1cb8 = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\sectioins\\statistic-box.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/sectioins/statistic-box" */))
const _982f47a4 = () => interopDefault(import('..\\pages\\web\\guarantee\\tianan\\text\\text.js' /* webpackChunkName: "pages/web/guarantee/tianan/text/text" */))
const _4f54029e = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _5ab53208 = () => interopDefault(import('..\\pages\\error\\404' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/appbh",
    component: _1c84ad1a,
    alias: ["/appbh/index.html","/appbh.html"],
    name: "appbh"
  }, {
    path: "/error/404",
    component: _b90f88d8,
    alias: ["/error/404/index.html","/error/404.html"],
    name: "error-404"
  }, {
    path: "/error/pay-success",
    component: _b90f518c,
    alias: ["/error/pay-success/index.html","/error/pay-success.html"],
    name: "error-pay-success"
  }, {
    path: "/jiantou/claim",
    component: _ec69f29c,
    alias: ["/jiantou/claim/index.html","/jiantou/claim.html"],
    name: "jiantou-claim"
  }, {
    path: "/web/bhquery",
    component: _5e0b5b70,
    alias: ["/web/bhquery/index.html","/web/bhquery.html"],
    name: "web-bhquery"
  }, {
    path: "/web/ggzybh",
    component: _6af45e1d,
    alias: ["/web/ggzybh/index.html","/web/ggzybh.html"],
    name: "web-ggzybh"
  }, {
    path: "/web/online-service",
    component: _026253c7,
    alias: ["/web/online-service/index.html","/web/online-service.html"],
    name: "web-online-service"
  }, {
    path: "/web/register",
    component: _0e03107a,
    alias: ["/web/register/index.html","/web/register.html"],
    name: "web-register"
  }, {
    path: "/web/zbdl",
    component: _c17fab9c,
    alias: ["/web/zbdl/index.html","/web/zbdl.html"],
    name: "web-zbdl"
  }, {
    path: "/branch/bhtong/aboutus",
    component: _d61f2672,
    alias: ["/branch/bhtong/aboutus/index.html","/branch/bhtong/aboutus.html"],
    name: "branch-bhtong-aboutus"
  }, {
    path: "/branch/bhtong/bh-query",
    component: _85d369be,
    alias: ["/branch/bhtong/bh-query/index.html","/branch/bhtong/bh-query.html"],
    name: "branch-bhtong-bh-query"
  }, {
    path: "/branch/bhtong/finance",
    component: _3d988478,
    alias: ["/branch/bhtong/finance/index.html","/branch/bhtong/finance.html"],
    name: "branch-bhtong-finance"
  }, {
    path: "/branch/bhtong/help-center",
    component: _46cc8991,
    alias: ["/branch/bhtong/help-center/index.html","/branch/bhtong/help-center.html"],
    name: "branch-bhtong-help-center"
  }, {
    path: "/branch/bhtong/index",
    component: _1d7d2a80,
    alias: ["/branch/bhtong/index/index.html","/branch/bhtong/index.html"],
    name: "branch-bhtong-index"
  }, {
    path: "/branch/bhtong/joinpartner",
    component: _d6686d18,
    alias: ["/branch/bhtong/joinpartner/index.html","/branch/bhtong/joinpartner.html"],
    name: "branch-bhtong-joinpartner"
  }, {
    path: "/branch/common/aboutus",
    component: _cb3b9d10,
    alias: ["/branch/common/aboutus/index.html","/branch/common/aboutus.html"],
    name: "branch-common-aboutus"
  }, {
    path: "/branch/fybh/index",
    component: _ae79dc42,
    alias: ["/branch/fybh/index/index.html","/branch/fybh/index.html"],
    name: "branch-fybh-index"
  }, {
    path: "/branch/mancheng/bh-query",
    component: _8b336588,
    alias: ["/branch/mancheng/bh-query/index.html","/branch/mancheng/bh-query.html"],
    name: "branch-mancheng-bh-query"
  }, {
    path: "/branch/mancheng/index",
    component: _3022d645,
    alias: ["/branch/mancheng/index/index.html","/branch/mancheng/index.html"],
    name: "branch-mancheng-index"
  }, {
    path: "/branch/ysbh/index",
    component: _591a2aa6,
    alias: ["/branch/ysbh/index/index.html","/branch/ysbh/index.html"],
    name: "branch-ysbh-index"
  }, {
    path: "/branch/zceb/index",
    component: _0a107468,
    alias: ["/branch/zceb/index/index.html","/branch/zceb/index.html"],
    name: "branch-zceb-index"
  }, {
    path: "/sys/all/all",
    component: _37f6610e,
    alias: ["/sys/all/all/index.html","/sys/all/all.html"],
    name: "sys-all-all"
  }, {
    path: "/sys/applybh/paybh",
    component: _d203755a,
    alias: ["/sys/applybh/paybh/index.html","/sys/applybh/paybh.html"],
    name: "sys-applybh-paybh"
  }, {
    path: "/sys/applybh/payend",
    component: _16db29c4,
    alias: ["/sys/applybh/payend/index.html","/sys/applybh/payend.html"],
    name: "sys-applybh-payend"
  }, {
    path: "/sys/bhcheck/detail",
    component: _bcda9eec,
    alias: ["/sys/bhcheck/detail/index.html","/sys/bhcheck/detail.html"],
    name: "sys-bhcheck-detail"
  }, {
    path: "/sys/bhcheck/list",
    component: _11c56e97,
    alias: ["/sys/bhcheck/list/index.html","/sys/bhcheck/list.html"],
    name: "sys-bhcheck-list"
  }, {
    path: "/sys/bhcheck/print",
    component: _07630884,
    alias: ["/sys/bhcheck/print/index.html","/sys/bhcheck/print.html"],
    name: "sys-bhcheck-print"
  }, {
    path: "/sys/coupons/list",
    component: _3aae1562,
    alias: ["/sys/coupons/list/index.html","/sys/coupons/list.html"],
    name: "sys-coupons-list"
  }, {
    path: "/sys/filecustomerdwmg/list",
    component: _2ad5c6be,
    alias: ["/sys/filecustomerdwmg/list/index.html","/sys/filecustomerdwmg/list.html"],
    name: "sys-filecustomerdwmg-list"
  }, {
    path: "/sys/ggzy/bh-auto",
    component: _20c012b4,
    alias: ["/sys/ggzy/bh-auto/index.html","/sys/ggzy/bh-auto.html"],
    name: "sys-ggzy-bh-auto"
  }, {
    path: "/sys/mailaddressmg/list",
    component: _2b252568,
    alias: ["/sys/mailaddressmg/list/index.html","/sys/mailaddressmg/list.html"],
    name: "sys-mailaddressmg-list"
  }, {
    path: "/sys/ordermg/bh-detail",
    component: _07268ee9,
    alias: ["/sys/ordermg/bh-detail/index.html","/sys/ordermg/bh-detail.html"],
    name: "sys-ordermg-bh-detail"
  }, {
    path: "/sys/ordermg/list",
    component: _2c5de1e5,
    alias: ["/sys/ordermg/list/index.html","/sys/ordermg/list.html"],
    name: "sys-ordermg-list"
  }, {
    path: "/sys/ordermg/list-usertype-1",
    component: _7974250e,
    alias: ["/sys/ordermg/list-usertype-1/index.html","/sys/ordermg/list-usertype-1.html"],
    name: "sys-ordermg-list-usertype-1"
  }, {
    path: "/sys/receiptinfomg/list",
    component: _e4f04f56,
    alias: ["/sys/receiptinfomg/list/index.html","/sys/receiptinfomg/list.html"],
    name: "sys-receiptinfomg-list"
  }, {
    path: "/sys/userinfo/list",
    component: _0cbb3670,
    alias: ["/sys/userinfo/list/index.html","/sys/userinfo/list.html"],
    name: "sys-userinfo-list"
  }, {
    path: "/sys/zb-notice/detail",
    component: _b2b95636,
    alias: ["/sys/zb-notice/detail/index.html","/sys/zb-notice/detail.html"],
    name: "sys-zb-notice-detail"
  }, {
    path: "/sys/zb-notice/list",
    component: _4bd96db2,
    alias: ["/sys/zb-notice/list/index.html","/sys/zb-notice/list.html"],
    name: "sys-zb-notice-list"
  }, {
    path: "/web/all/all",
    component: _e0963880,
    alias: ["/web/all/all/index.html","/web/all/all.html"],
    name: "web-all-all"
  }, {
    path: "/web/query/main",
    component: _a664fdde,
    alias: ["/web/query/main/index.html","/web/query/main.html"],
    name: "web-query-main"
  }, {
    path: "/branch/bhtong/bh-query/res",
    component: _6535f4a2,
    alias: ["/branch/bhtong/bh-query/res/index.html","/branch/bhtong/bh-query/res.html"],
    name: "branch-bhtong-bh-query-res"
  }, {
    path: "/branch/bhtong/news/detail",
    component: _7bca6fe4,
    alias: ["/branch/bhtong/news/detail/index.html","/branch/bhtong/news/detail.html"],
    name: "branch-bhtong-news-detail"
  }, {
    path: "/branch/bhtong/news/newslist",
    component: _57fdaec4,
    alias: ["/branch/bhtong/news/newslist/index.html","/branch/bhtong/news/newslist.html"],
    name: "branch-bhtong-news-newslist"
  }, {
    path: "/sys/ggzy/virtual-money-acc/detail",
    component: _32725f8a,
    alias: ["/sys/ggzy/virtual-money-acc/detail/index.html","/sys/ggzy/virtual-money-acc/detail.html"],
    name: "sys-ggzy-virtual-money-acc-detail"
  }, {
    path: "/sys/ggzy/virtual-money-acc/list",
    component: _482fc688,
    alias: ["/sys/ggzy/virtual-money-acc/list/index.html","/sys/ggzy/virtual-money-acc/list.html"],
    name: "sys-ggzy-virtual-money-acc-list"
  }, {
    path: "/sys/ggzy/zb-file/detail",
    component: _0da6fd0a,
    alias: ["/sys/ggzy/zb-file/detail/index.html","/sys/ggzy/zb-file/detail.html"],
    name: "sys-ggzy-zb-file-detail"
  }, {
    path: "/sys/ggzy/zb-file/list",
    component: _10fa49d2,
    alias: ["/sys/ggzy/zb-file/list/index.html","/sys/ggzy/zb-file/list.html"],
    name: "sys-ggzy-zb-file-list"
  }, {
    path: "/sys/ggzy/zb-notice/detail",
    component: _73bb1f26,
    alias: ["/sys/ggzy/zb-notice/detail/index.html","/sys/ggzy/zb-notice/detail.html"],
    name: "sys-ggzy-zb-notice-detail"
  }, {
    path: "/sys/ggzy/zb-notice/form",
    component: _4590a54e,
    alias: ["/sys/ggzy/zb-notice/form/index.html","/sys/ggzy/zb-notice/form.html"],
    name: "sys-ggzy-zb-notice-form"
  }, {
    path: "/sys/ggzy/zb-notice/form-fast-add",
    component: _1d3c4554,
    alias: ["/sys/ggzy/zb-notice/form-fast-add/index.html","/sys/ggzy/zb-notice/form-fast-add.html"],
    name: "sys-ggzy-zb-notice-form-fast-add"
  }, {
    path: "/sys/ggzy/zb-notice/list",
    component: _1130d433,
    alias: ["/sys/ggzy/zb-notice/list/index.html","/sys/ggzy/zb-notice/list.html"],
    name: "sys-ggzy-zb-notice-list"
  }, {
    path: "/sys/ggzy/zb-pro/list",
    component: _81d7c6c4,
    alias: ["/sys/ggzy/zb-pro/list/index.html","/sys/ggzy/zb-pro/list.html"],
    name: "sys-ggzy-zb-pro-list"
  }, {
    path: "/sys/ggzy/zb-pro/list-bd",
    component: _a53f6efe,
    alias: ["/sys/ggzy/zb-pro/list-bd/index.html","/sys/ggzy/zb-pro/list-bd.html"],
    name: "sys-ggzy-zb-pro-list-bd"
  }, {
    path: "/sys/guarantee/hanhua/hhly-apply",
    component: _6568a46c,
    alias: ["/sys/guarantee/hanhua/hhly-apply/index.html","/sys/guarantee/hanhua/hhly-apply.html"],
    name: "sys-guarantee-hanhua-hhly-apply"
  }, {
    path: "/web/guarantee/hanhua/form",
    component: _2b8e694a,
    alias: ["/web/guarantee/hanhua/form/index.html","/web/guarantee/hanhua/form.html"],
    name: "web-guarantee-hanhua-form"
  }, {
    path: "/web/guarantee/hanhua/hhly-apply",
    component: _ad385af6,
    alias: ["/web/guarantee/hanhua/hhly-apply/index.html","/web/guarantee/hanhua/hhly-apply.html"],
    name: "web-guarantee-hanhua-hhly-apply"
  }, {
    path: "/web/guarantee/huanghe/form",
    component: _19a570c6,
    alias: ["/web/guarantee/huanghe/form/index.html","/web/guarantee/huanghe/form.html"],
    name: "web-guarantee-huanghe-form"
  }, {
    path: "/web/guarantee/tianan/form",
    component: _6075962b,
    alias: ["/web/guarantee/tianan/form/index.html","/web/guarantee/tianan/form.html"],
    name: "web-guarantee-tianan-form"
  }, {
    path: "/web/guarantee/yangguang/form",
    component: _bc4d77b2,
    alias: ["/web/guarantee/yangguang/form/index.html","/web/guarantee/yangguang/form.html"],
    name: "web-guarantee-yangguang-form"
  }, {
    path: "/web/guarantee/zhonghua/form-xm",
    component: _5a2221bc,
    alias: ["/web/guarantee/zhonghua/form-xm/index.html","/web/guarantee/zhonghua/form-xm.html"],
    name: "web-guarantee-zhonghua-form-xm"
  }, {
    path: "/branch/bhtong/aboutus/sectioins/company-introduction",
    component: _4e5aad04,
    alias: ["/branch/bhtong/aboutus/sectioins/company-introduction/index.html","/branch/bhtong/aboutus/sectioins/company-introduction.html"],
    name: "branch-bhtong-aboutus-sectioins-company-introduction"
  }, {
    path: "/branch/bhtong/aboutus/sectioins/platform-introduction",
    component: _98f4d7ec,
    alias: ["/branch/bhtong/aboutus/sectioins/platform-introduction/index.html","/branch/bhtong/aboutus/sectioins/platform-introduction.html"],
    name: "branch-bhtong-aboutus-sectioins-platform-introduction"
  }, {
    path: "/branch/bhtong/aboutus/sectioins/statistic-box",
    component: _3f7b1cb8,
    alias: ["/branch/bhtong/aboutus/sectioins/statistic-box/index.html","/branch/bhtong/aboutus/sectioins/statistic-box.html"],
    name: "branch-bhtong-aboutus-sectioins-statistic-box"
  }, {
    path: "/web/guarantee/tianan/text/text",
    component: _982f47a4,
    alias: ["/web/guarantee/tianan/text/text/index.html","/web/guarantee/tianan/text/text.html"],
    name: "web-guarantee-tianan-text-text"
  }, {
    path: "/",
    component: _4f54029e,
    alias: ["/index.html"],
    name: "index"
  }, {
    path: "*",
    component: _5ab53208,
    name: "404"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
